var _path, _path2, _polygon, _polygon2, _polygon3, _polygon4, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-1--inject-92"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-1--inject-92",
    cx: 250.59,
    cy: 333.76,
    rx: 232.98,
    ry: 134.51,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-1--inject-92"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-1--inject-92",
    cx: 417.65,
    cy: 351.31,
    rx: 46.07,
    ry: 26.6,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-1--inject-92",
    cx: 77.9,
    cy: 347.57,
    rx: 48.1,
    ry: 27.77,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-1--inject-92",
    d: "M334.57,337.53a4.23,4.23,0,0,1-2.07-.51l-42.62-24.61a2,2,0,0,1,.16-3.68l38.26-17.67a5,5,0,0,1,2-.41,5.11,5.11,0,0,1,2.54.62L367.08,311a2.23,2.23,0,0,1,.2,3.92l-30.22,21.83a4.24,4.24,0,0,1-2.49.75Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-1--inject-92",
    d: "M160.21,331.69a4.09,4.09,0,0,0,2.06-.52l42.63-24.61a2,2,0,0,0-.17-3.68l-38.25-17.66a4.9,4.9,0,0,0-2-.41,5.14,5.14,0,0,0-2.54.62l-34.2,19.75a2.38,2.38,0,0,0-1.27,1.91,2.35,2.35,0,0,0,1.08,2l30.22,21.83a4.27,4.27,0,0,0,2.49.75Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-1--inject-92",
    d: "M102.06,360l137.24,79.2a4.6,4.6,0,0,0,4.15,0L384.3,357.81a1.27,1.27,0,0,0,0-2.4l-137.23-79.2a4.62,4.62,0,0,0-4.16,0L102.06,357.57A1.26,1.26,0,0,0,102.06,360Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-1--inject-92"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Girl--inject-1--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M358.29,260.11v53a1.5,1.5,0,0,0,.67,1.17l1.81,1a1.5,1.5,0,0,0,1.34,0l1.81-1a1.5,1.5,0,0,0,.67-1.17v-53a.76.76,0,0,0-.77-.77h-4.75A.77.77,0,0,0,358.29,260.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.82,259.34h-1.6a.77.77,0,0,0-.78.77V315c0,.43.3.6.67.39l1.81-1a1.5,1.5,0,0,0,.67-1.17v-53A.76.76,0,0,0,363.82,259.34Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.87,277.61v53a1.47,1.47,0,0,0,.67,1.16l1.81,1a1.5,1.5,0,0,0,1.34,0l1.81-1a1.47,1.47,0,0,0,.67-1.16v-53a.78.78,0,0,0-.78-.78h-4.75A.78.78,0,0,0,327.87,277.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.39,276.83h-1.6a.78.78,0,0,0-.77.78v54.84c0,.43.3.6.67.39l1.81-1a1.47,1.47,0,0,0,.67-1.16v-53A.78.78,0,0,0,333.39,276.83Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.89,238.69a2.86,2.86,0,0,1-2.47,3.18l-.36,0a2.86,2.86,0,0,1-2.82-2.5c-1.63-13.09.7-42.36,6.3-58.86.57-1.69,2.21-2.06,3.76-1.17h0c1.18.68,2,1.72,1.59,3C330.52,197.86,328.31,226.08,329.89,238.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.86,246.22a1.88,1.88,0,0,0,.57-.09,1.8,1.8,0,0,0,1.15-2.28c-4.19-12.75-24.81-24.1-38.12-24.1a1.81,1.81,0,0,0,0,3.62c12,0,31,10.48,34.69,21.61A1.8,1.8,0,0,0,362.86,246.22Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.81,229.69a1.77,1.77,0,0,0,.56-.09,1.81,1.81,0,0,0,1.16-2.28c-4.36-13.25-25.6-24-38.85-22.61a1.81,1.81,0,0,0,.37,3.6c11.74-1.19,31.22,8.53,35,20.14A1.81,1.81,0,0,0,364.81,229.69Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.83,216.59a1.87,1.87,0,0,0,.73-.15,1.81,1.81,0,0,0,.93-2.39c-6.24-14.2-28.42-25.86-40.42-24.2a1.81,1.81,0,1,0,.49,3.59c10.61-1.47,31,9.38,36.62,22.07A1.79,1.79,0,0,0,368.83,216.59Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.44,201.39a2.84,2.84,0,0,1,1.17,3.59c-6.54,15.28-10,33.94-10,54.37v2.74l-.22.23a1.14,1.14,0,0,1-.86.35,3.36,3.36,0,0,1-1.19-.29,5.05,5.05,0,0,0-.58-.18,2.85,2.85,0,0,1-2.84-2.85c0-21.19,3.6-40.62,10.46-56.62a2.84,2.84,0,0,1,4-1.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.59,261.43v.69a4.56,4.56,0,0,1-1.67,3.28L332.7,287.25a3.47,3.47,0,0,1-3.47.18L286.6,262.82a4,4,0,0,1-1.79-3.11V259a3.53,3.53,0,0,1,1.88-2.94l38.25-17.66a4.48,4.48,0,0,1,3.67.16l34.19,19.76A4,4,0,0,1,364.59,261.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.8,258.32l-34.19-19.76a4.48,4.48,0,0,0-3.67-.16l-38.25,17.66c-1,.48-1.08,1.33-.09,1.91l42.63,24.61a3.47,3.47,0,0,0,3.47-.18l30.22-21.83A1.24,1.24,0,0,0,362.8,258.32Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311,300.66c.76.53,1.64,1.14,1.73,2a8.5,8.5,0,0,1-1.25,5.16c-1.34,2.24-1.73,6.05-1.55,8.55s1.26,8.73-1.31,11.81-9.78,5.87-10.73,1.35,4.34-23.75,4.34-23.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.45,304.43a69.33,69.33,0,0,0-1,10.34c0,3.78-.54,6.56-2.19,7.92s-4.44,1.76-3.92-.92,1.86-16,1.86-16Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,234.48s-15.89,9.81-22.23,15.14-8.5,7.51-9.27,10.9c-.82,3.58,1.44,9.39,5.26,19.35,1,2.69,7.84,18.58,7.84,18.58l9.23-29.93,18.84-17.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.14,329.61c.69.27.92,1.78,1.09,2.89s1.26,2.38,0,4.4-3.89,2.74-5.58,5.5-2.56,6.53-8.46,8.09-10.55-.2-11.75-1.92-.29-3.46,3.42-5.82c3.95-2.52,5.06-3.25,5.06-3.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.13,317.65s-2.51,8.11-4.08,11.86-2.6,6.16-5.52,9.54c-.63.74-2.08,2.11-2.6,2.71a1.15,1.15,0,0,0,.12,1.77c1.31,1.24,6.82,1.52,9.9-.8s4.53-5.54,6.37-7.41c.92-.93,1.78-1.82,2.42-2.48a2.5,2.5,0,0,0,.61-2.38l-.21-.85c-.43-1.78,1.9-9.09,1.9-9.09Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.46,234.69c3.07,6.64,1.79,13.93-.21,20s-10,12.81-16.91,16.91-17.55,9.09-19.62,10-2.29,2.18-2,6.15-1.05,10.44-5.43,18.57c-4.63,8.58-7.26,14.16-7.26,14.16a9.18,9.18,0,0,1-9.29-2.24s7.39-39.23,9.14-44.41,21.19-22,21.19-22-6.55-11.46-8.1-17.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.18,276.37c1.07-5.23,4.9-9.36,8.57-12.85,3-2.86,10.72-9.79,13.4-12.2a32.17,32.17,0,0,1-1.93-5.66s1.53,2.75,2.88,4.82h0l.85,1.24.13.18h0L322,252c-1.15,1-19.44,16.9-21.14,21.91-1,2.88-3.68,16.25-5.9,27.57C295.16,299.75,297.18,281.36,298.18,276.37Z",
    style: {
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M328.81,180.47l-40.19-4.41s-24.5-14-26.78-18.31c-2.53-4.76-3.32-12.13-4.76-16.6s-6.57,5-3.44,20.23c.45,2.15,3.32,3.26,5.43,5.68,5.77,6.62,15.51,14.18,21.29,18.43a21.84,21.84,0,0,0,10.15,4.09l36.34,4.74Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.35,209.33c-.55,5.06-2.45,26.11-2.45,26.11,10.89,8.78,35.19,6.85,39.61-.22A88.19,88.19,0,0,1,347.7,220l3.58-14.59s-6.62-9-.95-21.69l-9.15-1.63-12.71-1.86-5.51-.37s-7.49,8.09-9.53,13.3C312.12,196.52,309.52,202.48,315.35,209.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.2,225.88l-.32-1.11c-.79-2.86-1.18-4.77-1.18-4.77l3.58-14.59h0l0,0,0,0c-.06-.06-.3-.58-.45-.75h0c-1-1.18-3.49-4.79-2.69-11.16h0s-2.66,8.84.23,13.08l-2.73,12.26-3.95,5.75,4.79-1.88a84.64,84.64,0,0,1,1.89,9c.11,1.72-4,7.43-12.67,9.62,7.79-.35,14.71-2.57,16.88-6h0A81.14,81.14,0,0,1,349.2,225.88Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.08,223.17c-1.91-7.45-9.5-24-11.8-30-2.63-6.84-6.35-9.41-11.24-9.48-1.8,2.32-5,15.47,1.19,21.94,2.36,5,10,19.87,10,19.87-.18,1.34-5.93,18.37-8,22.92a3.63,3.63,0,0,1-1.86,1.78c-2.18.95-3.18,2.12-4.92,3.47-1.36,1-2.41,1.21-2.31,1.63a2,2,0,0,0,2.35,1.25,13.72,13.72,0,0,0,3.06-1.12,18.18,18.18,0,0,1-3.65,4.56c-3.31,3-3.14,5.53,2.51,6.43,3.54.56,6.69-1.2,10.53-8.61,1.1-2.14,2.52-5.26,3.63-8.09,2.63-6.71,5.45-10.69,7.28-15.13C372.71,227.58,373.82,226,373.08,223.17Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.91,173.32l6.72.18A16.93,16.93,0,0,0,354,157h0a20.29,20.29,0,0,0-19.74-20.84h0a20.29,20.29,0,0,0-20.84,19.74h0A16.93,16.93,0,0,0,329.91,173.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.72,147.17l5-1.77a2.59,2.59,0,0,0-3.34-1.72A2.81,2.81,0,0,0,350.72,147.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.77,145.87l1.56-5.11a2.59,2.59,0,0,0-3.36,1.68A2.81,2.81,0,0,0,350.77,145.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.53,144.94c-2.18,1.2-5,6.52-5,17.83,0,9.58,3,12,4.54,12.76s4.56.39,7.5,0l-.08,4.72s-5.25,5-5.06,7.66,6.74,4,10.59,1.54,7.18-7.34,7.18-7.34l.28-13.28s1.68,1.72,4.66-.75c2.47-2,3.38-5.57,1.55-7.53a4.2,4.2,0,0,0-6.71,1.15s-4.06-.65-9.93-4.5A22,22,0,0,1,321.53,144.94Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,164.83l1.55-5.11a2.61,2.61,0,0,0-3.36,1.68A2.8,2.8,0,0,0,340,164.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328,159.69a1.23,1.23,0,0,0,1.11,1.33,1.25,1.25,0,1,0-1.11-1.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.73,168.77l-2.83.81a1.45,1.45,0,0,0,1.8,1A1.53,1.53,0,0,0,326.73,168.77Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.78,156.87l2.48-1.63a1.42,1.42,0,0,0-2-.47A1.56,1.56,0,0,0,317.78,156.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.19,159.48a1.2,1.2,0,1,0,1.3-1.15A1.22,1.22,0,0,0,318.19,159.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.79 158.97 324.64 166.83 320.86 165.54 324.79 158.97",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.55,175.51c3.09-.32,9.47-2,10.53-4.44a6.47,6.47,0,0,1-2.31,3.13c-1.94,1.57-8.28,3.23-8.28,3.23Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.11,180.55h0A12.58,12.58,0,0,1,351.52,168V146.79h0a12.59,12.59,0,0,1,12.59,12.59Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-1--inject-92"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Boy--inject-1--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.82,253.26v53.06a1.5,1.5,0,0,1-.67,1.17l-1.81,1a1.53,1.53,0,0,1-1.35,0l-1.81-1a1.5,1.5,0,0,1-.67-1.17V253.26a.77.77,0,0,1,.78-.77H135A.77.77,0,0,1,135.82,253.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.29,252.49h1.6a.77.77,0,0,1,.78.77v54.88c0,.43-.3.6-.67.39l-1.81-1a1.5,1.5,0,0,1-.67-1.17V253.26A.77.77,0,0,1,130.29,252.49Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.27,270.77v53.06a1.51,1.51,0,0,1-.68,1.17l-1.81,1a1.5,1.5,0,0,1-1.34,0l-1.81-1a1.5,1.5,0,0,1-.67-1.17V270.77a.77.77,0,0,1,.77-.77h4.76A.77.77,0,0,1,166.27,270.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.73,270h1.61a.77.77,0,0,1,.77.77v54.88c0,.43-.3.6-.67.39l-1.81-1a1.5,1.5,0,0,1-.67-1.17V270.77A.77.77,0,0,1,160.73,270Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.24,231.82a2.88,2.88,0,0,0,.58,2.1,2.82,2.82,0,0,0,1.9,1.08l.35,0a2.83,2.83,0,0,0,2.82-2.49c1.64-13.1-.69-42.4-6.29-58.91-.58-1.7-2.22-2.06-3.77-1.17h0c-1.18.68-2,1.72-1.59,3C163.61,191,165.82,219.21,164.24,231.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.24,239.36a1.81,1.81,0,0,1-1.72-2.38c4.2-12.76,24.83-24.11,38.15-24.11a1.81,1.81,0,1,1,0,3.62c-12,0-31,10.49-34.71,21.63A1.81,1.81,0,0,1,131.24,239.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3,222.82a1.88,1.88,0,0,1-.57-.09,1.81,1.81,0,0,1-1.15-2.29c4.36-13.26,25.61-24,38.87-22.62a1.81,1.81,0,1,1-.37,3.6c-11.75-1.19-31.24,8.54-35.06,20.15A1.81,1.81,0,0,1,129.3,222.82Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.27,209.71a1.72,1.72,0,0,1-.73-.16,1.8,1.8,0,0,1-.93-2.38c6.24-14.21,28.45-25.89,40.45-24.22a1.81,1.81,0,1,1-.49,3.59c-10.62-1.48-31.06,9.39-36.64,22.08A1.83,1.83,0,0,1,125.27,209.71Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.66,194.49a2.85,2.85,0,0,0-1.17,3.6c6.54,15.29,10,34,10,54.41v2.74l.22.23a1.14,1.14,0,0,0,.86.35,3.41,3.41,0,0,0,1.19-.29,4.08,4.08,0,0,1,.58-.18,2.84,2.84,0,0,0,2.84-2.85c0-21.21-3.6-40.65-10.46-56.66a2.84,2.84,0,0,0-4-1.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.51,254.58v.69a4.54,4.54,0,0,0,1.68,3.29l30.24,21.86a3.47,3.47,0,0,0,3.47.18L207.56,256a4,4,0,0,0,1.8-3.11v-.71a3.55,3.55,0,0,0-1.88-2.94l-38.29-17.68a4.48,4.48,0,0,0-3.67.17L131.3,251.47A4,4,0,0,0,129.51,254.58Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.3,251.47l34.22-19.77a4.48,4.48,0,0,1,3.67-.17l38.29,17.68c1,.48,1.07,1.33.08,1.9L164.9,275.74a3.47,3.47,0,0,1-3.47-.17l-30.24-21.85A1.24,1.24,0,0,1,131.3,251.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.69,
    y: 317.89,
    width: 8.38,
    height: 14.59,
    transform: "translate(361.76 650.37) rotate(180)",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.81 318.09 219.55 318.55 219.34 316.79 219.26 315.48 218.46 302.66 208.93 303 210.29 315.79 210.38 316.77 210.81 318.09",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.05,330.17v-.72c1.08,0,4.92,8.12,8.59,11.47,2.92,2.66,8.06,6.31,7.93,8.84-.16,3.26-4.81,4.7-8.82,3.76-3.13-.73-7.61-2.63-9.76-4.95s-2.84-5.37-4-6.88-3.71-3.21-4.32-5c-.33-1,.07-3.08.53-4.86s.9-3.44,1.46-3.29v1a7.28,7.28,0,0,0,4.63,1.57C182.68,331.2,185.06,331.2,185.05,330.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.27,315.48c.44,0,.85.56,1.92,1.52,1.29,1.17,4,2.26,6,3,3.32,1.3,11.84,2.68,14.75,3.68,1.82.63,1.63,3.38-.71,5.13-1.74,1.3-7.52,2.94-12.86,2.25-2.91-.38-7.43-2-9.58-2.1-2.36-.15-6.68-.21-8.52-1.24s-1.39-3.66-1.1-5.89c.32-2.45.29-6.16,1.1-6.07l.09,1c1.16,1.45,6.82,1.36,9,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.52,235.57c-1.87,13.17.65,15.7,13.16,28.31,6.73,6.78,21.32,18.41,21.32,18.41s-2.42,5.25-2.5,14.68c-.08,8.31.84,28.22.84,28.22s5.06,2.82,8.95.36c0,0,10.12-47.67,9.4-50.73-.52-2.16-16.49-22.74-16.49-22.74l-4.48-2.85,29,17.85s-.88,8-.29,13.09c1.23,10.6,4.08,17.41,7,30.78,0,0,6.92,1.13,10-1.26,0,0,.19-45.78.19-49.82,0-6.14-26.67-24.48-31.72-28.74-2.88-2.44-6.1-5-6.1-5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.52,235.57c-1.87,13.17.65,15.7,13.16,28.31,6.73,6.78,21.32,18.41,21.32,18.41s-2.42,5.25-2.5,14.68c-.08,8.31.84,28.22.84,28.22s5.06,2.82,8.95.36c0,0,10.12-47.67,9.4-50.73-.52-2.16-16.49-22.74-16.49-22.74l-4.48-2.85,29,17.85s-.88,8-.29,13.09c1.23,10.6,4.08,17.41,7,30.78,0,0,6.92,1.13,10-1.26,0,0,.19-45.78.19-49.82,0-6.14-26.67-24.48-31.72-28.74-2.88-2.44-6.1-5-6.1-5Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.72,249.23s4.08-2,7.71-9.72a19.57,19.57,0,0,1-2.5,7.89c-1.63,2.55,23.76,19.68,23.76,19.68Z",
    style: {
      opacity: 0.35000000000000003
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M172.35,170.66l41.88-.3S242,162,244.3,157.75c2.53-4.76,3.32-12.13,4.76-16.6,1.08-3.33,4.07-1.64,3.68,9.48-.1,3,.55,6.92-.24,10.75-.45,2.15-2.76,3.9-5.43,5.68a203.6,203.6,0,0,1-25,13.64c-3.32,1.42-5.34,2.08-11.32,2.46-8.52.56-29,1.75-29,1.75Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.61,170.25l25.53-.45s6.1,6.88,1.1,15.11c-.69.36-18.91,1.62-18.91,1.62Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.61,170.25l25.53-.45s6.1,6.88,1.1,15.11c-.69.36-18.91,1.62-18.91,1.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.67,170.54c-1,.24-9.31,2.19-13,3.43V202l.17,35.88c6,6.57,36.41,3.58,40.13-10.39v-42c0-6.71-3.73-14.77-14-15.37Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.7 207.81 148.78 190.59 142.82 228.46 142.7 207.81",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.77,136.19a4.61,4.61,0,0,0-3.8,1.34c-1.63,1.67-1.29,4.76,0,11.85L154,150Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.17,134.14a8,8,0,0,0,3.16-.64c1.54-.89,1.95.87,1.1,2.4a7.21,7.21,0,0,1-5.85,3.9c-.05-.22-1.45-3.94-1.45-3.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.13,150c-.74.44-1.81-1-2.74-2s-3.93-2.29-5.44.88,1.33,7.5,3.7,8.24c4.09,1.28,4.71-1.34,4.71-1.34l.31,14.75s2.68,6.55,9.93,7.53,5.75-5,3.37-7.92v-4.49a25.82,25.82,0,0,0,5.51.28c3-.46,4.9-2.83,5.82-6.09,1.46-5.23,2.51-9.25,1.26-19.53-1.36-11.27-15-11.59-22-7.13S155.13,150,155.13,150Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.13,151.23c-.37,0-1.8-2.37-2.74-3.22-1.29-1.18.38-11.82.38-11.82s-1.31-4,1.25-6.71,7.49-2.22,11.11-2.35a32.47,32.47,0,0,0,12.93-2.6c5.13-2.23,5.52-2.49,6.15-.24s.88,7.43-2.18,10.89l-2.55.93s-1.38,1.23-6.17,1.81a71.06,71.06,0,0,1-13.27-.25c-1.39-.19-1.69,1.15-2.44,4.83C157,145.73,156.4,151.2,155.13,151.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.78,137l-4.53-2.43a2.5,2.5,0,0,1,3.43-1.13A2.7,2.7,0,0,1,152.78,137Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,165.66s-6.71-1.35-9.06-2.6a7.68,7.68,0,0,1-3.24-3.21,10.65,10.65,0,0,0,1.84,3.79c1.72,2.19,10.46,3.81,10.46,3.81Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.85,148.62a1.35,1.35,0,1,1-1.35-1.41A1.39,1.39,0,0,1,169.85,148.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.57,143.06l-3.19.79a1.72,1.72,0,0,1,1.24-2A1.6,1.6,0,0,1,168.57,143.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.16,157.52l3.07,1.15a1.61,1.61,0,0,1-2.08,1A1.72,1.72,0,0,1,170.16,157.52Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.21,143.87l-3.12-1.13a1.59,1.59,0,0,1,2.07-1A1.75,1.75,0,0,1,181.21,143.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.14,148.36a1.35,1.35,0,1,1-1.35-1.41A1.38,1.38,0,0,1,180.14,148.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.91 147.61 173.36 155.7 177.58 154.26 172.91 147.61",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.23,220.18c-.5-2.4,4.86-26.14,7-33.65l10.43,10.93-6.21,23c.09,1.59,1.4,11.08,3.44,16.63a4.26,4.26,0,0,0,2,2.27c2.48,1.33,3.54,2.79,5.46,4.54,1.49,1.37,2.71,1.65,2.56,2.13a2.3,2.3,0,0,1-2.88,1.25,16.68,16.68,0,0,1-3.5-1.6,21.49,21.49,0,0,0,3.85,5.7c3.61,3.85,3.93,6.35-2.79,6.86-4.21.33-7.75-2-11.55-11.11-1.09-2.62-2.47-6.42-3.5-9.85A160,160,0,0,1,128.23,220.18Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.78,190.6c2.09-7.43.46-14.81-2.57-17.67-7.74,1.32-9.69,5-11.81,12.16-3.27,11.07-4.93,18.26-4.93,18.26,1.93,2.58,10.71,5.79,14.33,4.69Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.78,190.6c2.09-7.43.46-14.81-2.57-17.67-7.74,1.32-9.69,5-11.81,12.16-3.27,11.07-4.93,18.26-4.93,18.26,1.93,2.58,10.71,5.79,14.33,4.69Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.94,145.29a3.51,3.51,0,0,0,0,7h.64a3.51,3.51,0,0,0,0-7Zm-4.13,3.51a4.18,4.18,0,0,1,4.13-4.22h.64a4.22,4.22,0,0,1,0,8.43h-.64A4.17,4.17,0,0,1,162.81,148.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.55,145.29a3.51,3.51,0,0,0,0,7h.64a3.51,3.51,0,0,0,0-7Zm-4.13,3.51a4.18,4.18,0,0,1,4.13-4.22h.64a4.22,4.22,0,0,1,0,8.43h-.64A4.17,4.17,0,0,1,175.42,148.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.66,148a2.75,2.75,0,0,1,2.19-1.14,2.23,2.23,0,0,1,1.91.73l.55-.42a2.85,2.85,0,0,0-2.5-1,3.37,3.37,0,0,0-2.74,1.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.77,148.4h10.4v-.67H152.1A2.38,2.38,0,0,1,152.77,148.4Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-1--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M414.4,139.59c-9.29-.87-14.74,5.4-17.69,11.72-3.55,7.65-10,24.13-10,24.13s-27.45,4.65-31.12,5.4l2.72,7.75s25.58-.56,29.57-.78c3.53-.19,6.42.36,8.52-3.2s9.86-24.46,9.86-24.46Z",
    style: {
      fill: "#ffc4c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.4,139.59s-6.89-1.4-10.72,1.29c-5.07,3.56-6.55,8.11-9.15,13.66s-4.38,10.29-4.38,10.29,7.2,7.77,13.53,6.85S414.4,139.59,414.4,139.59Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.55,180.84c-9.57,1.61-12.6,6.31-14.48,8.81s-2.26,5.7-.08,8.29,3.34,2.15,7.71-2.65c2.32-2.55,4.78-4.34,5.37-4.34s-2,2.81-.6,4.75,2.47-1.56,3.38-2.67a11.75,11.75,0,0,0,2.87-7",
    style: {
      fill: "#ffc4c3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.39,
    y: 330.18,
    width: 9.48,
    height: 16.24,
    transform: "translate(-9.5 12.73) rotate(-1.64)",
    style: {
      fill: "#ffc4c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.49,341.86l0-1.35c-.89.42-2.77,8.52-6.44,12.06-2.91,2.81-6.9,6.08-7.85,9.15s5.82,4.75,8.6,4.17c3.23-.66,8.79-3.11,10.15-5.27s1.92-5.3,3-6.89,3.7-3.4,4.27-5.21c.31-1-.15-3.15-.68-5s-1-3.5-1.59-3.32c0,.2,0,1,0,1a7.53,7.53,0,0,1-4.69,1.74C438.88,343.1,435.51,342.92,435.49,341.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "418.52 334.88 409.06 335.48 408.09 318.31 418.03 317.7 418.52 334.88",
    style: {
      fill: "#ffc4c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.87,332.56c-.49,0-.87.73-1.92,1.94a20.81,20.81,0,0,1-5.47,4.17c-3.5,1.88-10.32,4.81-13.4,6.31-1.93.93-1.77,3.29.29,4.57s6.95,2.11,12.76.64c3.17-.8,7.23-3.87,9.86-3.78s7.54-.1,9.44-1.49,1-4.22.42-6.65c-.67-2.66-1.54-6.81-2.42-6.6l0,.92c-1.09,1.76-7,2.63-9.5,1.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.21,208.73c.26,9.06.17,61.76.17,61.76.29,2.6,2.93,7.16,3.4,16.54.67,13.6-3.5,51.12-3.5,51.12a12.49,12.49,0,0,1-10.55.51s-5.75-50.53-7.84-64c-1.82-11.71-5.25-43.58-5.25-43.58l-3.36,38.51a53.92,53.92,0,0,1,1.61,15c-.27,6.24-.92,44.87-.92,44.87a12.93,12.93,0,0,1-10.92,1.15s-8.26-54.8-8.54-60.52c-.31-6.51.39-73.11.39-73.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.21,208.73c.26,9.06.17,61.76.17,61.76.29,2.6,2.93,7.16,3.4,16.54.67,13.6-3.5,51.12-3.5,51.12a12.49,12.49,0,0,1-10.55.51s-5.75-50.53-7.84-64c-1.82-11.71-5.25-43.58-5.25-43.58l-3.36,38.51a53.92,53.92,0,0,1,1.61,15c-.27,6.24-.92,44.87-.92,44.87a12.93,12.93,0,0,1-10.92,1.15s-8.26-54.8-8.54-60.52c-.31-6.51.39-73.11.39-73.11Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.64,231.13a35.17,35.17,0,0,1-13.41-7.19s2.68,4.7,10.38,8.92l-.05,33.54Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.51,143.54c2.08.93,3.26,3.93,4.1,6.06.74,1.89,3,5,3,8.58l-1.6,18.2.7,32.57a43.91,43.91,0,0,1-46.27-3.6s1.2-42,1.2-49.39c0-.33,0-.67,0-1a16.64,16.64,0,0,1,13.11-15.29c2.56-.58,16.64,2.34,16.64,2.34l9.1,1.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.72,108.79a13,13,0,1,1-13-13A13,13,0,0,1,427.72,108.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.21,118.06s-2.11,9.92-2.95,11.55a4.53,4.53,0,0,1-2.6,2.1l.15-7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.56,103.84a4.89,4.89,0,0,1,4.05,1.42c1.74,1.78.77,7.35-1.4,12.8l-4,.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,118.52c.8.47,1.94-1.06,2.92-2.09s4.2-2.43,5.8.94-1.41,8-3.94,8.78c-4.36,1.37-5-1.43-5-1.43l-.33,17.63h0c-5.41,7-20.45,6.42-14.19-.84l0-6.27a27.87,27.87,0,0,1-5.88.31c-3.2-.5-5.22-3-6.19-6.5-1.56-5.57-2.16-10.07-.83-21,1.45-12,15.42-12.13,23-7.38S432,118.52,432,118.52Z",
    style: {
      fill: "#ffc4c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,119.86c.4,0,1.93-2.52,2.92-3.43,1.38-1.25-.4-12.59-.4-12.59a5.37,5.37,0,0,0-1.32-5.74c-1.89-2.07-3.94-3.38-9.38-3.67a110.51,110.51,0,0,0-11.13.52c-5.37.37-7.35-1-10.43-1.82-2.36-.66-2.63,7.85,3.33,10.67,0,0,1.94,1.26,7,1.88a75.49,75.49,0,0,0,14.15-.27c1.48-.2,1.79,1.23,2.59,5.15C430.11,114,430.69,119.83,432,119.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.56,104.72l4.82-2.59a2.66,2.66,0,0,0-3.65-1.21A2.88,2.88,0,0,0,434.56,104.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.31,135.24s7.15-1.44,9.65-2.77a8.24,8.24,0,0,0,3.46-3.42,11.32,11.32,0,0,1-2,4c-1.82,2.34-11.14,4.06-11.14,4.06Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.66,116.73a1.45,1.45,0,0,0,1.43,1.48,1.49,1.49,0,0,0,0-3A1.48,1.48,0,0,0,417.66,116.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.18,111.32l3.06,1.69a1.82,1.82,0,0,0-.71-2.44A1.7,1.7,0,0,0,419.18,111.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,126.63l-3.27,1.23a1.72,1.72,0,0,0,2.23,1.08A1.82,1.82,0,0,0,418,126.63Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.29,112.51l2.79-2.15a1.69,1.69,0,0,0-2.43-.38A1.86,1.86,0,0,0,405.29,112.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.15,116.32a1.46,1.46,0,0,0,1.43,1.49,1.49,1.49,0,0,0,1.44-1.5,1.44,1.44,0,1,0-2.87,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.45 114.96 412.98 123.58 408.48 122.05 413.45 114.96",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.6,130.28c.79-.49,4.76,1.09,7.34,4.19s3.13,7.66,2.46,8.67-10.32-2.48-10.32-2.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.13,131.56c-1.31,3.25-17.28,26.23-21.11,31.73-10.65-4.7-3.36-17.19-3.36-17.19S452.13,128,454,125a6.78,6.78,0,0,0,.83-2.52c.25-1.63,1.29-21.53.4-27.55a4.41,4.41,0,0,0-1.57-2.72c-2.22-1.86-3-3.56-4.55-5.73-1.23-1.7-2.4-2.24-2.15-2.69a2.39,2.39,0,0,1,3.18-.66,16.72,16.72,0,0,1,3.19,2.35,22.21,22.21,0,0,0-2.7-6.56c-2.83-4.65-2.63-7.24,4.27-6.35,4.32.55,8.49,4,10.43,13.92a86.11,86.11,0,0,1,.8,10.88c.38,8.43.53,21.74.3,27.57C466.3,127.89,466.44,128.3,465.13,131.56Z",
    style: {
      fill: "#ffc4c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.21,143.54l12.39-13.26s-.3,10.62,9.8,12.86l-13.15,19.8c-1.46,3-7,.2-8.55-6.08C435.52,148.09,437.21,143.54,437.21,143.54Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-1--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.73,138.85c7.58-.65,10.93,1.56,15,7.27,4.85,6.89,14.58,24.12,14.58,24.12s27.84-.27,31.58-.18l-1.3,8.1s-25.29,4-29.25,4.47c-3.5.43-6.26,1.49-9-1.65s-14-22.33-14-22.33Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.84,170.06c9.7-.11,13.52,4,15.81,6.11s3.23,5.21,1.55,8.15-2.92,2.7-8.06-1.25c-2.74-2.1-5.48-3.42-6-3.32s2.44,2.42,1.43,4.57-2.71-1.11-3.8-2a11.71,11.71,0,0,1-4.07-6.42",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-1--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.53,333.43a49.81,49.81,0,0,0-.76,8c-.09,4.84-1,6.55-1.09,10.52-.14,4.53.65,6.23,2.49,8.78s6.66,4.86,8.7.55,1.78-7.13,1.13-11.58-.76-7.13-1.15-10.64c-.35-3.09-.76-5.44-.76-5.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.26,295.41l-15.93-.29c.24,10.63,1.93,28.33,2.2,38.31,0,1.87,0,14.59.66,18.45,1.07,5.81,8,5,8.32,1.55s-.44-18.32-.42-19.85C57,327.18,60,310.49,61.6,299,61.68,298.44,62.18,296,62.26,295.41Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.67,325.15s-.83.05-1,.72-.19,2.06-.52,3.37a19.28,19.28,0,0,0-.57,6.31c.28,1.48,3.67,3.69,6,4.08s5.58,2.68,7.4,4.39a17.85,17.85,0,0,0,10.3,4.05c3.87,0,6.56-1.29,7.84-3.36s-1.16-2.32-5.59-5.19l-3.43-2.23c-7-4.58-9.57-7-11.55-11.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.64,322.66c-.12-3.29,1.56-27.54,1.56-27.54l-13.7,1.54C85.74,316,86,322.58,85.64,325.39h0a2.74,2.74,0,0,0-.09.81c0,3.76,4.25,5.79,7.56,8.29,1.31,1,4.66,4,8.6,5.38,2.54.86,7.25,1.19,7.85-.35-4-3.08-9.5-7.09-12.7-10.6C95.33,327.24,94.75,326,94.64,322.66Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.38,192.75c-7.22,16.43-3.09,65.87-3.09,65.87-.22,2.65-3.25,7.86-4.38,19.52-1.33,13.78,2.46,50.65,2.46,50.65s3.64,2.72,8.92.19c0,0,9.64-54.18,11.37-67.88,1.51-12,5.73-36.78,5.73-36.78L81.29,261a71.38,71.38,0,0,0-2.61,11.79c-.78,8.06,7.07,48.49,7.07,48.49s3.67,1.94,8.88-.17c0,0,3.48-52.24,4.21-61.94,1.22-16.3-3.11-67.15-6.1-76.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.39,224.32l1.77-12.17s10.27-1.37,14.93-5.75A16.86,16.86,0,0,1,79,214.05l-1.82,11L80.31,257Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.08,136.7H66.35a14.5,14.5,0,0,1-14.5-14.5v-9.94a20,20,0,0,1,19.95-20h2.33a20,20,0,0,1,20,20Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.29,139.16h0c-3.07.21-5.5.64-7.05,1.51a8.8,8.8,0,0,0-4.86,8.25c-.05,4.2,1,6.89,2.25,13.8L58.13,176s-2.3,9.2-5.81,19c12.3,6.87,26.9,5.92,35.57,2.2a16.91,16.91,0,0,0,6.74-4.76c.21-1.42-1.55-15.05-1.55-22.67,2.9-7.29,3.11-8.88,1.89-13.69-2.28-8.95-11.11-17.66-15-17.34Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.37,197.79h0c-26.32,1.86-27.65-15.3-26.15-17.93s4.5,0,4.5,0S59,168.85,60,165.27c2-6.62,2.35-17.3,2.35-17.3l-6.71-5.33a9,9,0,0,0-2.3,6.28c-.05,4.2,1,6.89,2.24,13.8L58.13,176s-2.3,9.2-5.81,19A42.85,42.85,0,0,0,86.37,197.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.11,91.45l1.37,5.23a2.63,2.63,0,0,1-3.33-1.83A2.84,2.84,0,0,1,59.11,91.45Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,93.79l4.51,3a2.62,2.62,0,0,1-3.69.87A2.84,2.84,0,0,1,55,93.79Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.71,101.28c2.23,1.32,5,6.93,4.71,18.69-.23,10-3.46,12.43-5.08,13.14s-4.75.27-7.79-.23v6s4.2,4.88,3.94,7.62-6.07,3.39-10,.71A25.44,25.44,0,0,1,66,140.44v-15.5s-2,2.23-5.34,0a5.75,5.75,0,0,1-1.11-8.59A4,4,0,0,1,66,118.14s4.85.18,11.31-3.37A18.15,18.15,0,0,0,86.71,101.28Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.18,117.47a1.25,1.25,0,1,1-2.5.11,1.25,1.25,0,1,1,2.5-.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.63,125.91l2.91.93a1.51,1.51,0,0,1-1.89,1A1.61,1.61,0,0,1,80.63,125.91Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.46,113.62l-2.54-1.76a1.48,1.48,0,0,1,2.11-.43A1.62,1.62,0,0,1,89.46,113.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.87,116.56a1.26,1.26,0,0,1-1.18,1.36,1.28,1.28,0,0,1-1.32-1.24,1.25,1.25,0,1,1,2.5-.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.75 115.84 82.95 123.39 86.92 122.16 82.75 115.84",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.55,132.88c-3.2-.42-9.8-2.32-10.82-4.92A6.74,6.74,0,0,0,70,131.28c2,1.69,8.51,3.59,8.51,3.59Z",
    style: {
      fill: "#f0997a"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.45,224.22a.5.5,0,0,1-.2.45l-.54.31L39.16,207.53a1.54,1.54,0,0,1-.69-1.2v-31l31,17.91Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.45,224.22a.5.5,0,0,1-.2.45l-.54.31L39.16,207.53a1.54,1.54,0,0,1-.69-1.2v-31l31,17.91Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.93,224.52c0,.45-.31.62-.69.4l-29.6-17.09a1.55,1.55,0,0,1-.7-1.2v-31l31,17.91Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.93,224.52c0,.45-.31.62-.69.4l-29.6-17.09a1.55,1.55,0,0,1-.7-1.2v-31l31,17.91Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.53,183v23a1.52,1.52,0,0,0,.7,1.21l27.29,15.76v3l2.65-1.53v0c.2,0,.35-.19.35-.48v-26.3l-31-17.9-2.89,1.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.62,225.52c0,.44-.31.62-.7.4L35.33,208.83a1.52,1.52,0,0,1-.7-1.2V181.32l31,17.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.61 199.22 68.51 197.55 37.52 179.65 34.63 181.32 65.61 199.22",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.3,199.56a.84.84,0,0,1,.2.18.68.68,0,0,1,.2.36.19.19,0,0,1,0,.13c0,.24-.18.32-.42.18a.83.83,0,0,1-.27-.26.78.78,0,0,1-.16-.41.07.07,0,0,1,0-.05C63.91,199.49,64.08,199.43,64.3,199.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.89,198.54a1.9,1.9,0,0,0,.24,1,1.22,1.22,0,0,0,.9.63,1.41,1.41,0,0,0,.67-.05.68.68,0,0,0-.2-.36.92.92,0,0,1-.62-.05,1.15,1.15,0,0,1-.59-1.15,3.81,3.81,0,0,1,1.72-3c.95-.55,1.72-.12,1.73,1l.39.23a1.47,1.47,0,0,0,0-.21,1.9,1.9,0,0,0-.23-1h0a1.25,1.25,0,0,0-.91-.62,1.77,1.77,0,0,0-1.18.27A4.17,4.17,0,0,0,62.89,198.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.57,197.66l2.05,29.68.38-.22a.77.77,0,0,0,.35-.6L63.1,197.35Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.57,197.66l2.05,29.68.38-.22a.77.77,0,0,0,.35-.6L63.1,197.35Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.82,226.89c0,.45-.31.63-.69.4L34.53,210.2a1.54,1.54,0,0,1-.69-1.2l-2.26-29.71,31,17.91Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.45 193.22 38.47 175.31 31.57 179.3 62.57 197.19 69.45 193.22",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.45 193.22 38.47 175.31 31.57 179.3 62.57 197.19 69.45 193.22",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,190.48a1.26,1.26,0,0,1,.09,1.1,1.81,1.81,0,0,1-.82.88,4.22,4.22,0,0,1-3.85,0,2,2,0,0,1-.74-.69,1.44,1.44,0,0,1,.74-2,4.22,4.22,0,0,1,3.85,0,1.9,1.9,0,0,1,.73.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,192.12a1,1,0,0,0,0-2,3.79,3.79,0,0,0-3.44,0,1,1,0,0,0,0,2A3.82,3.82,0,0,0,61,192.12Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.45,188.7l.52-.3a1.15,1.15,0,0,0,0-2.18l-13.43-7.76a4.22,4.22,0,0,0-3.79,0l-.52.3a1.16,1.16,0,0,0,0,2.19l13.44,7.75A4.13,4.13,0,0,0,54.45,188.7Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.46 193.69 62.6 197.65 62.57 197.19 69.45 193.22 69.46 193.69",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.46 193.69 62.6 197.65 62.57 197.19 69.45 193.22 69.46 193.69",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.46,139.69c-7.26.12-11.11.56-13.76,10-2,7-6.83,23.6-8.22,30.57-.64,3.21.07,16,1.05,30.53.17,2.55.18,5.48,1.6,6.88,3.15,3.12,9.78,5.05,10.46,3l-4.07-2.35,1.89-34.7,8.36-23C58.27,162.38,65,147,61.46,139.69Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.37,202.62c.25,1.65,1.91,4,3.17,6.21,1.06,1.83,1.82,5.16,2.33,5.73s-.84,1.71-2.52.28-2.23-3.17-2.86-4l.37,8.22-4.23-1Z",
    style: {
      fill: "#ffbda7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubbles--inject-1--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.8,113.21,164,106.13l3-8.74V92l-9.27,5.35v5.35l4,6.9a.57.57,0,0,0,.27.24h0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.8,113.21,164,106.13l3-8.74V92l-9.27,5.35v5.35l4,6.9a.57.57,0,0,0,.27.24h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.93,49.52a6.12,6.12,0,0,0-2.78-4.81l-2.26-1.31a6.16,6.16,0,0,0-5.55,0L144.65,63.46a6.13,6.13,0,0,0-2.78,4.81v38.17a6.16,6.16,0,0,0,2.78,4.81l2.26,1.31a6.18,6.18,0,0,0,5.56,0l11.15-6.45,4,6.89a.59.59,0,0,0,1.07-.11l4.2-12.12,14.28-8.28a6.12,6.12,0,0,0,2.78-4.81Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.87,106.44a6.13,6.13,0,0,0,2.78,4.81l2.26,1.31a6.2,6.2,0,0,0,5.08.22c-1.31.49-2.3-.24-2.3-1.83V72.79a5.69,5.69,0,0,1,.81-2.74l-7.82-4.51a5.69,5.69,0,0,0-.81,2.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.84,48.73c-.32-1.18-1.4-1.56-2.68-.82L152.46,68a5.5,5.5,0,0,0-2,2.07l-7.82-4.51a5.68,5.68,0,0,1,2-2.07L179.33,43.4a6.18,6.18,0,0,1,5.56,0l2.27,1.31A6.12,6.12,0,0,1,189.84,48.73Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.72,76.58h0a.59.59,0,0,0-.2,0l-2.65-.15a.44.44,0,0,1-.45-.44c0-.42.06-.83.06-1.24a9.58,9.58,0,0,0-.06-1.32,1.3,1.3,0,0,1,.3-.78l3-3.59a.83.83,0,0,0,.18-.74l-1.41-3.11a.27.27,0,0,0-.08-.1h0c-.12-.06-.29,0-.46.14l-3.16,2.89a.56.56,0,0,1-.69.12,4.89,4.89,0,0,0-1.36-.79.49.49,0,0,1-.32-.55l1-4.43a.28.28,0,0,0-.13-.32.56.56,0,0,0-.3,0l-3.09.31a.87.87,0,0,0-.68.47l-1.68,4.5a1.41,1.41,0,0,1-.68.66,14,14,0,0,0-1.91,1.11c-.26.17-.55.19-.67,0l-1.58-2.42c-.11-.17-.37-.13-.57.08l-3.4,3.59a.93.93,0,0,0-.27.75l.95,3.2a1.1,1.1,0,0,1-.17.78,26.13,26.13,0,0,0-1.57,2.71,1.22,1.22,0,0,1-.73.55l-2.91.7a1,1,0,0,0-.66.55l-1.46,4.93c-.08.23.09.43.36.44l2.65.15a.44.44,0,0,1,.45.43,13.68,13.68,0,0,0,0,2.56,1.29,1.29,0,0,1-.29.79l-3,3.59a.83.83,0,0,0-.18.74l1.41,3.11a.28.28,0,0,0,.09.1h0a.2.2,0,0,0,.11,0h0a.58.58,0,0,0,.35-.16l3.16-2.9a.56.56,0,0,1,.69-.11,5.27,5.27,0,0,0,1.36.78.51.51,0,0,1,.32.56l-1,4.43a.28.28,0,0,0,.13.31h0a.44.44,0,0,0,.29,0l3.09-.3a.85.85,0,0,0,.68-.47l1.68-4.51a1.48,1.48,0,0,1,.68-.65c.32-.15.65-.33,1-.52s.62-.38.94-.59.55-.19.66,0l1.58,2.42a.18.18,0,0,0,.08.07.4.4,0,0,0,.49-.15l3.41-3.59a.93.93,0,0,0,.26-.74l-.95-3.2a1.1,1.1,0,0,1,.17-.78,24.69,24.69,0,0,0,1.57-2.71,1.18,1.18,0,0,1,.74-.55l2.9-.7a1,1,0,0,0,.66-.55L183.88,77A.34.34,0,0,0,183.72,76.58Zm-15.52,12-.17,0-.13,0-.27,0-.32,0H167a3.13,3.13,0,0,1-2.92-2,6.58,6.58,0,0,1-.47-2.53,13.9,13.9,0,0,1,3.84-8.8,10.92,10.92,0,0,1,2.34-1.9,8.26,8.26,0,0,1,.78-.4,5,5,0,0,1,2.2-.46h.37a3.11,3.11,0,0,1,2.43,1.93c1.32,2.9-.19,8-3.36,11.32A8.85,8.85,0,0,1,168.2,88.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.24,113.21l3.76-7.08-3-8.74V92l9.27,5.35v5.35l-4,6.9a.52.52,0,0,1-.27.24h0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.24,113.21l3.76-7.08-3-8.74V92l9.27,5.35v5.35l-4,6.9a.52.52,0,0,1-.27.24h0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.11,49.52a6.12,6.12,0,0,1,2.78-4.81l2.26-1.31a6.18,6.18,0,0,1,5.56,0l34.68,20.06a6.13,6.13,0,0,1,2.78,4.81v38.17a6.13,6.13,0,0,1-2.78,4.81l-2.26,1.31a6.16,6.16,0,0,1-5.55,0l-11.16-6.45-4,6.89a.59.59,0,0,1-1.07-.11l-4.2-12.12-14.28-8.28a6.12,6.12,0,0,1-2.78-4.81Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.17,106.44a6.13,6.13,0,0,1-2.78,4.81l-2.26,1.31a6.19,6.19,0,0,1-5.08.22c1.31.49,2.3-.24,2.3-1.83V72.79a5.69,5.69,0,0,0-.81-2.74l7.82-4.51a5.69,5.69,0,0,1,.81,2.73Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.2,48.73c.33-1.18,1.4-1.56,2.68-.82L346.58,68a5.5,5.5,0,0,1,1.95,2.07l7.82-4.51a5.6,5.6,0,0,0-2-2.07L319.71,43.4a6.18,6.18,0,0,0-5.56,0l-2.27,1.31A6.15,6.15,0,0,0,309.2,48.73Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.88,99.38,328,96.53a1.4,1.4,0,0,1-.57-1.1V93.35c0-.42.26-.62.57-.43l4.93,2.84a1.4,1.4,0,0,1,.58,1.11v2.07C333.46,99.37,333.2,99.56,332.88,99.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.55,78.57a4.7,4.7,0,0,1,.88,1.79,2.33,2.33,0,0,1-1-1c-.06-.13-.25-.54-.09-.73S326.48,78.51,326.55,78.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.42,77.68a.5.5,0,0,1,.25.37,2,2,0,0,1-.25,1.26,3.38,3.38,0,0,1-.24-1.54C330.21,77.65,330.26,77.59,330.42,77.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.29,83l0,0c.06,0,.11.1.18.27a.49.49,0,0,1-.09.62c-.2.18-.56.16-1-.13C333.75,83.18,334.08,83,334.29,83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.67,74.54c0,8.21,5.08,12.5,5.08,15.81h0v1.39l5.35,3.1v-1.4c0-3.31,5.08-1.74,5.08-9.94,0-5.72-3.48-12.35-7.76-14.82S322.67,68.83,322.67,74.54Zm3.13,3.25c.22-.28.53-.27.87,0a6.22,6.22,0,0,1,1.42,2.77,2.09,2.09,0,0,0,.74,0,2.56,2.56,0,0,0,1.2-.68,5.27,5.27,0,0,1-.47-2.67c.11-.47.44-.6.86-.35a1.92,1.92,0,0,1,.86,1.34,2.9,2.9,0,0,1-.47,2.13,13.28,13.28,0,0,0,1.2,2.06,8.5,8.5,0,0,0,.74.9c.42-.88.92-1.29,1.42-1.13a1.65,1.65,0,0,1,.87,1,1.48,1.48,0,0,1-.14,1.68c-.36.32-1,.27-1.78-.33a11.81,11.81,0,0,0-.48,1.72,34.93,34.93,0,0,0-.64,6.59c0,.24-.14.35-.31.26a.77.77,0,0,1-.33-.61,35.65,35.65,0,0,1,.66-6.81,13.82,13.82,0,0,1,.47-1.72,9.36,9.36,0,0,1-.82-1,14.3,14.3,0,0,1-1.25-2.12,2.86,2.86,0,0,1-1.25.68,2.57,2.57,0,0,1-.82.06c.18.69.33,1.45.47,2.27a45.65,45.65,0,0,1,.66,7.57c0,.23-.14.33-.32.23h0a.79.79,0,0,1-.32-.62,46.23,46.23,0,0,0-.64-7.34c-.15-.87-.31-1.62-.48-2.26a3.57,3.57,0,0,1-1.78-1.73A1.87,1.87,0,0,1,325.8,77.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.42,65.69a1.78,1.78,0,0,1-.67-1.42V62c0-.57.3-.86.67-.64a1.74,1.74,0,0,1,.67,1.41V65C331.09,65.61,330.79,65.9,330.42,65.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.47,64.87a1.48,1.48,0,0,1-.58-.85l-.74-2.41c-.19-.6-.08-1.17.24-1.27s.73.31.92.91l.74,2.41c.18.6.07,1.16-.25,1.26A.37.37,0,0,1,325.47,64.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.84,68.36a1.28,1.28,0,0,1-.33-.33l-1.29-1.89a1.75,1.75,0,0,1-.24-1.55c.18-.39.59-.32.91.15l1.29,1.89a1.75,1.75,0,0,1,.24,1.55A.38.38,0,0,1,321.84,68.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.52,75.21,319,74.36a1.78,1.78,0,0,1-.67-1.42c0-.57.3-.86.67-.64l1.49.85a1.78,1.78,0,0,1,.67,1.42C321.19,75.14,320.89,75.43,320.52,75.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.56,84a1.51,1.51,0,0,1-.58-.85c-.19-.6-.08-1.17.24-1.27l1.29-.4c.32-.1.73.31.91.9s.08,1.17-.24,1.27l-1.29.4A.44.44,0,0,1,320.56,84Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.28,95.39a1,1,0,0,1-.33-.33l-1.29-1.88a1.76,1.76,0,0,1-.24-1.55c.18-.39.59-.32.91.15l1.29,1.89a1.73,1.73,0,0,1,.24,1.54A.37.37,0,0,1,340.28,95.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.81,87.51l-1.49-.86a1.76,1.76,0,0,1-.66-1.42c0-.57.29-.85.66-.64l1.49.86a1.76,1.76,0,0,1,.67,1.41C342.48,87.43,342.18,87.72,341.81,87.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,78.26a1.48,1.48,0,0,1-.58-.85c-.19-.6-.08-1.17.24-1.26l1.29-.41c.32-.1.73.31.91.91s.08,1.17-.24,1.26l-1.29.41A.4.4,0,0,1,339,78.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.37,70.59a1.08,1.08,0,0,1-.33-.34,1.77,1.77,0,0,1-.25-1.54l.75-1.56c.18-.38.59-.31.91.16a1.77,1.77,0,0,1,.25,1.54L336,70.41A.38.38,0,0,1,335.37,70.59Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-1--inject-92"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-1--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250,344.76v77.62a2.21,2.21,0,0,0,1,1.74l2.14,1.24a2.22,2.22,0,0,0,2,0l2.14-1.24a2.21,2.21,0,0,0,1-1.74V344.76c0-.64-.45-.9-1-.58l-2.14,1.24a2.22,2.22,0,0,1-2,0L251,344.18C250.48,343.86,250,344.12,250,344.76Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.19,425.36l2.14-1.24a2.21,2.21,0,0,0,1-1.74V344.76c0-.64-.45-.9-1-.58l-2.14,1.24a2.23,2.23,0,0,0-1,1.74v77.62C254.19,425.42,254.64,425.68,255.19,425.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.74,279.37V357a2.21,2.21,0,0,0,1,1.74l2.14,1.23a2.16,2.16,0,0,0,2,0l2.14-1.23a2.21,2.21,0,0,0,1-1.74V279.37c0-.64-.45-.9-1-.58L141.9,280a2.22,2.22,0,0,1-2,0l-2.14-1.23C137.19,278.47,136.74,278.73,136.74,279.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.9,360l2.14-1.23a2.21,2.21,0,0,0,1-1.74V279.37c0-.64-.45-.9-1-.58L141.9,280a2.22,2.22,0,0,0-1,1.75v77.61C140.89,360,141.34,360.29,141.9,360Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.58,288.41V366a2.24,2.24,0,0,0,1,1.74l2.14,1.24a2.22,2.22,0,0,0,2,0l2.14-1.24a2.21,2.21,0,0,0,1-1.74V288.41c0-.64-.45-.9-1-.58l-2.14,1.23a2.22,2.22,0,0,1-2,0l-2.14-1.23C348,287.51,347.58,287.77,347.58,288.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.74,369l2.14-1.24a2.21,2.21,0,0,0,1-1.74V288.41c0-.64-.45-.9-1-.58l-2.14,1.23a2.25,2.25,0,0,0-1,1.75v77.61C351.74,369.07,352.19,369.33,352.74,369Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-1--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.88,286.46v-.73a4,4,0,0,1,1.84-3.17l124.22-71.75a4,4,0,0,1,3.67,0l121,69.85a4,4,0,0,1,1.84,3.17v.73a4,4,0,0,1-1.84,3.17L243.42,359.49a4.09,4.09,0,0,1-3.67,0l-121-69.85A4.05,4.05,0,0,1,116.88,286.46Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.65
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.88,286.46v-.73a4,4,0,0,1,1.84-3.17l124.22-71.75a4,4,0,0,1,3.67,0l121,69.85a4,4,0,0,1,1.84,3.17v.73a4,4,0,0,1-1.84,3.17L243.42,359.49a4.09,4.09,0,0,1-3.67,0l-121-69.85A4.05,4.05,0,0,1,116.88,286.46Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M241.59,355v5a3.91,3.91,0,0,1-1.84-.44l-121-69.85a4,4,0,0,1-1.83-3.17v-.74a4,4,0,0,1,1.49-2.93c-.66.56-.55,1.35.34,1.88l121,69.85A3.68,3.68,0,0,0,241.59,355Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.59,355v5a3.91,3.91,0,0,1-1.84-.44l-121-69.85a4,4,0,0,1-1.83-3.17v-.74a4,4,0,0,1,1.49-2.93c-.66.56-.55,1.35.34,1.88l121,69.85A3.68,3.68,0,0,0,241.59,355Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.72,284.67l121,69.86a4.09,4.09,0,0,0,3.67,0l124.22-71.76a1.11,1.11,0,0,0,0-2.11l-121-69.85a4,4,0,0,0-3.67,0L118.72,282.56A1.11,1.11,0,0,0,118.72,284.67Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.72,284.67l121,69.86a4.09,4.09,0,0,0,3.67,0l124.22-71.76a1.11,1.11,0,0,0,0-2.11l-121-69.85a4,4,0,0,0-3.67,0L118.72,282.56A1.11,1.11,0,0,0,118.72,284.67Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "freepik--shadow--inject-1--inject-92",
    points: "332.21 274.36 334.28 271.92 329.97 273.07",
    style: {
      fill: "#455a64",
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--green-laptop--inject-1--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.05,256.08v.58a2.43,2.43,0,0,0,1.2,2.08l41.88,24.17a2.31,2.31,0,0,0,1.19.32,2.38,2.38,0,0,0,1.21-.32l22.82-13.14a2.39,2.39,0,0,0,1.2-2.07v-.8h0a.32.32,0,0,1-.15.27l-25.07,14.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M258.05,256.08v.58a2.43,2.43,0,0,0,1.2,2.08l41.88,24.17a2.31,2.31,0,0,0,1.19.32,2.38,2.38,0,0,0,1.21-.32l22.82-13.14a2.39,2.39,0,0,0,1.2-2.07v-.8h0a.32.32,0,0,1-.15.27l-25.07,14.47Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M258.05,256.08l24.83-14.34a1.46,1.46,0,0,1,1.43,0l43.08,24.88a.32.32,0,0,1,0,.55l-25.07,14.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.05,256.08l24.83-14.34a1.46,1.46,0,0,1,1.43,0l43.08,24.88a.32.32,0,0,1,0,.55l-25.07,14.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M258.05,256.08l24.83-14.34a1.46,1.46,0,0,1,1.43,0l43.08,24.88a.32.32,0,0,1,0,.55l-25.07,14.47Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "302.55 279.53 315.95 271.81 276.78 249.2 263.32 256.88 302.55 279.53"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "263.32 256.88 263.83 257.18 276.78 249.78 315.43 272.1 315.94 271.81 276.78 249.19 263.32 256.88",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "263.32 256.88 263.83 257.18 276.78 249.78 315.43 272.1 315.94 271.81 276.78 249.19 263.32 256.88"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "309.14 258.04 308.89 258.19 302.32 261.98 290.65 255.24 290.41 255.1 297.22 251.16 309.14 258.04"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "308.89 258.19 302.32 261.98 290.65 255.24 297.22 251.44 308.89 258.19",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "308.89 258.19 302.32 261.98 290.65 255.24 297.22 251.44 308.89 258.19"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M302.32,281.64v1.59a2.31,2.31,0,0,1-1.19-.32l-41.88-24.18a2.38,2.38,0,0,1-1.2-2.07v-.58Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.32,281.64v1.59a2.31,2.31,0,0,1-1.19-.32l-41.88-24.18a2.38,2.38,0,0,1-1.2-2.07v-.58Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M302.32,281.64v1.59a2.31,2.31,0,0,1-1.19-.32l-41.88-24.18a2.38,2.38,0,0,1-1.2-2.07v-.58Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M301.65,282a2.82,2.82,0,0,1-2.45-.19l-41.69-24.07a2.81,2.81,0,0,1-1.38-2l-4.57-27.22a3.71,3.71,0,0,1,0-.47,2.88,2.88,0,0,1,.83-2l43.34,25a2.11,2.11,0,0,1,1,1.46Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.32,281.64l-.28.16a2.33,2.33,0,0,1-.39.19l-4.93-29.46a2.11,2.11,0,0,0-1-1.46l-43.34-25a3.68,3.68,0,0,1,.58-.44l43.42,25.07a2.1,2.1,0,0,1,1,1.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M302.32,281.64l-.28.16a2.33,2.33,0,0,1-.39.19l-4.93-29.46a2.11,2.11,0,0,0-1-1.46l-43.34-25a3.68,3.68,0,0,1,.58-.44l43.42,25.07a2.1,2.1,0,0,1,1,1.47Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M296.31,251.62l.67-.39a2.14,2.14,0,0,1,.4.91l4.94,29.5-.28.16a2.33,2.33,0,0,1-.39.19l-4.93-29.46A2.21,2.21,0,0,0,296.31,251.62Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M278.16,256.86c-.3-1.82-2.18-4.24-4.2-5.4s-3.4-.63-3.09,1.19,2.18,4.24,4.2,5.41S278.47,258.69,278.16,256.86Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--black-laptop--inject-1--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.69,265.11v.79a2.32,2.32,0,0,0,1.15,2L182,280.67a2.29,2.29,0,0,0,1.16.31,2.33,2.33,0,0,0,1.17-.31L225,257.19a2.35,2.35,0,0,0,1.17-2v-.56l-43,24.83-24.34-14.06A.3.3,0,0,1,158.69,265.11Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.18,254.61l-24.11-13.93a1.43,1.43,0,0,0-1.39,0l-41.84,24.16a.31.31,0,0,0,0,.54l24.34,14.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.18,254.61l-24.11-13.93a1.43,1.43,0,0,0-1.39,0l-41.84,24.16a.31.31,0,0,0,0,.54l24.34,14.06Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "182.96 277.39 169.95 269.88 207.99 247.92 221.07 255.39 182.96 277.39",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.57 256.52 176.81 256.65 183.18 260.33 194.52 253.79 194.76 253.65 188.14 249.84 176.57 256.52",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.81 256.65 183.18 260.33 194.52 253.79 188.14 250.11 176.81 256.65",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "176.81 256.65 183.18 260.33 194.52 253.79 188.14 250.11 176.81 256.65",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.18,279.43V281a2.27,2.27,0,0,0,1.16-.31L225,257.19a2.34,2.34,0,0,0,1.16-2v-.56Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.18,279.43V281a2.27,2.27,0,0,0,1.16-.31L225,257.19a2.34,2.34,0,0,0,1.16-2v-.56Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.84,279.78a2.75,2.75,0,0,0,2.37-.19l40.5-23.38a2.75,2.75,0,0,0,1.34-1.92l4.43-26.44a2.28,2.28,0,0,0,0-.45,2.73,2.73,0,0,0-.82-2l-42.08,24.3a2.05,2.05,0,0,0-1,1.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.84,279.78a2.75,2.75,0,0,0,2.37-.19l40.5-23.38a2.75,2.75,0,0,0,1.34-1.92l4.43-26.44a2.28,2.28,0,0,0,0-.45,2.73,2.73,0,0,0-.82-2l-42.08,24.3a2.05,2.05,0,0,0-1,1.42Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M183.18,279.44l.28.15c.12.07.25.13.38.19l4.79-28.62a2.05,2.05,0,0,1,1-1.42l42.08-24.3a2.68,2.68,0,0,0-.56-.43L189,249.36a2.06,2.06,0,0,0-1,1.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.63,251.14l-4.79,28.61a2.64,2.64,0,0,1-.38-.18l-.28-.16,4.8-28.65a2,2,0,0,1,.32-.79l.65.38A2,2,0,0,0,188.63,251.14Z",
    style: {
      fill: "#263238",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.65,255.37a8.9,8.9,0,0,1,4.08-5.25c2-1.13,3.3-.61,3,1.16a9,9,0,0,1-4.09,5.25C207.7,257.66,206.35,257.14,206.65,255.37Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Notebooks--inject-1--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.33,273.92,134.21,284l-.4.61v.5a.72.72,0,0,0,.4.62l25.2,14.55a1.42,1.42,0,0,0,1.31,0l18.69-10.79V289Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.06,299.93a1.25,1.25,0,0,1-.65-.16l-25.2-14.55a.67.67,0,0,1,0-1.23l18.28-10.56L179.41,289l-18.69,10.79A1.27,1.27,0,0,1,160.06,299.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.49,272,134.41,282.4l-.18.26v1.94h0a.31.31,0,0,0,.18.26l25.21,14.55a.94.94,0,0,0,.89,0L178.59,289V287Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.59,287l-.23.13-2.94,1.7-.55.32-14.36,8.28a.94.94,0,0,1-.89,0l-25.21-14.55a.28.28,0,0,1,0-.52l.24-.13L152.49,272l25.87,14.94.06,0Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.06,297.58v1.94a.8.8,0,0,1-.44-.11l-25.21-14.55a.31.31,0,0,1-.18-.26v-1.94a.31.31,0,0,0,.18.26l25.21,14.55A.8.8,0,0,0,160.06,297.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.59,286.78l-3.26,1.88-.51.29-14.31,8.26a.94.94,0,0,1-.89,0l-22.57-13-.57-.32a5.64,5.64,0,0,1-1.83-1.59.43.43,0,0,0,0-.07.35.35,0,0,1-.06-.14.41.41,0,0,1,.32-.45,8,8,0,0,0,1.7-.71h0l15.9-9.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.22,286.55a.26.26,0,0,0,0,.49,1,1,0,0,0,.84,0,.26.26,0,0,0,0-.49A1,1,0,0,0,175.22,286.55Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.91,285a1.13,1.13,0,0,0-1.13.08,3.48,3.48,0,0,0-1.41,2,1,1,0,0,0,.3,0,3.16,3.16,0,0,1,1.27-1.81,1.11,1.11,0,0,1,.51-.16.68.68,0,0,1,.31.08,1.19,1.19,0,0,1,.42,1,2.09,2.09,0,0,1,0,.25l.29.17a3,3,0,0,0,0-.42A1.45,1.45,0,0,0,177.91,285Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.43,286.87s0,.05,0,.07l-.06,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.69,285.09c-.23.14-.23.36,0,.49a1,1,0,0,0,.84,0c.23-.13.23-.35,0-.49A1,1,0,0,0,172.69,285.09Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.39,283.52a1.13,1.13,0,0,0-1.13.08,3.57,3.57,0,0,0-1.42,2,1.06,1.06,0,0,0,.31,0,3.18,3.18,0,0,1,1.26-1.81,1.15,1.15,0,0,1,.52-.16.61.61,0,0,1,.3.08,1.16,1.16,0,0,1,.42,1,2.09,2.09,0,0,1,0,.25l.29.17a2,2,0,0,0,0-.42A1.47,1.47,0,0,0,175.39,283.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.17,283.64a.25.25,0,0,0,0,.48.87.87,0,0,0,.83,0c.24-.13.24-.35,0-.48A.87.87,0,0,0,170.17,283.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.86,282.06a1.13,1.13,0,0,0-1.13.08,3.57,3.57,0,0,0-1.42,2,.83.83,0,0,0,.31,0,3.19,3.19,0,0,1,1.27-1.81,1.06,1.06,0,0,1,.51-.15.6.6,0,0,1,.3.07,1.16,1.16,0,0,1,.43,1,2,2,0,0,1,0,.25l.3.17a3,3,0,0,0,0-.42A1.45,1.45,0,0,0,172.86,282.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.64,282.18a.25.25,0,0,0,0,.48.89.89,0,0,0,.84,0,.25.25,0,0,0,0-.48A.89.89,0,0,0,167.64,282.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.33,280.61a1.07,1.07,0,0,0-1.12.08,3.46,3.46,0,0,0-1.42,2,.78.78,0,0,0,.31,0,3.12,3.12,0,0,1,1.26-1.8,1,1,0,0,1,.52-.16.52.52,0,0,1,.3.08,1.13,1.13,0,0,1,.42,1,2,2,0,0,1,0,.25l.29.17a3,3,0,0,0,0-.42A1.43,1.43,0,0,0,170.33,280.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.12,280.72c-.23.13-.23.35,0,.49a.93.93,0,0,0,.83,0c.24-.14.24-.36,0-.49A.93.93,0,0,0,165.12,280.72Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.81,279.15a1.09,1.09,0,0,0-1.13.08,3.5,3.5,0,0,0-1.42,2,.82.82,0,0,0,.31,0,3.13,3.13,0,0,1,1.27-1.8,1,1,0,0,1,.51-.16.61.61,0,0,1,.3.08,1.14,1.14,0,0,1,.43,1,2.29,2.29,0,0,1,0,.25l.3.17a3.19,3.19,0,0,0,0-.42A1.43,1.43,0,0,0,167.81,279.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.59,279.26a.26.26,0,0,0,0,.49,1,1,0,0,0,.84,0,.26.26,0,0,0,0-.49A1,1,0,0,0,162.59,279.26Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.28,277.69a1.11,1.11,0,0,0-1.13.08,3.52,3.52,0,0,0-1.41,2,1,1,0,0,0,.31,0,3.11,3.11,0,0,1,1.26-1.81,1,1,0,0,1,.51-.16.65.65,0,0,1,.31.08,1.15,1.15,0,0,1,.42,1,2.18,2.18,0,0,1,0,.25l.29.17a3.07,3.07,0,0,0,0-.42A1.43,1.43,0,0,0,165.28,277.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.06,277.8c-.23.14-.23.36,0,.49a1,1,0,0,0,.84,0c.23-.13.23-.35,0-.49A1,1,0,0,0,160.06,277.8Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.76,276.23a1.13,1.13,0,0,0-1.13.08,3.54,3.54,0,0,0-1.42,2,1.06,1.06,0,0,0,.31,0,3.15,3.15,0,0,1,1.26-1.81,1.15,1.15,0,0,1,.52-.16.61.61,0,0,1,.3.08,1.16,1.16,0,0,1,.43,1,2.11,2.11,0,0,1,0,.25l.3.17a3,3,0,0,0,0-.42A1.45,1.45,0,0,0,162.76,276.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.54,276.35a.25.25,0,0,0,0,.48.89.89,0,0,0,.84,0,.25.25,0,0,0,0-.48A.89.89,0,0,0,157.54,276.35Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.23,274.77a1.13,1.13,0,0,0-1.13.08,3.51,3.51,0,0,0-1.41,2,.75.75,0,0,0,.3,0,3.19,3.19,0,0,1,1.27-1.81,1.08,1.08,0,0,1,.51-.16.61.61,0,0,1,.3.08,1.16,1.16,0,0,1,.43,1,2.09,2.09,0,0,1,0,.25l.29.17a3,3,0,0,0,0-.42A1.45,1.45,0,0,0,160.23,274.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,274.89a.25.25,0,0,0,0,.48.89.89,0,0,0,.84,0,.25.25,0,0,0,0-.48A.89.89,0,0,0,155,274.89Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.7,273.32a1.09,1.09,0,0,0-1.12.07,3.57,3.57,0,0,0-1.42,2,.8.8,0,0,0,.31,0,3.18,3.18,0,0,1,1.26-1.81,1.12,1.12,0,0,1,.52-.15.6.6,0,0,1,.3.07,1.16,1.16,0,0,1,.42,1,2,2,0,0,1,0,.25l.29.17a3,3,0,0,0,0-.42A1.43,1.43,0,0,0,157.7,273.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.49,273.43a.25.25,0,0,0,0,.48.87.87,0,0,0,.83,0c.24-.13.24-.35,0-.48A.87.87,0,0,0,152.49,273.43Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.18,271.86a1.09,1.09,0,0,0-1.13.08,3.5,3.5,0,0,0-1.42,2,.82.82,0,0,0,.31,0,3.13,3.13,0,0,1,1.27-1.8,1,1,0,0,1,.51-.16.52.52,0,0,1,.3.08,1.14,1.14,0,0,1,.43,1,1.94,1.94,0,0,1,0,.24l.3.17a2.93,2.93,0,0,0,0-.41A1.43,1.43,0,0,0,155.18,271.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.54,294.61a.28.28,0,0,1-.14-.53l13.9-8a.28.28,0,0,1,.39.1.28.28,0,0,1-.11.39l-13.9,8A.32.32,0,0,1,157.54,294.61Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.85,293.64a.28.28,0,0,1-.24-.14.29.29,0,0,1,.1-.39l13.91-8a.27.27,0,0,1,.38.11.28.28,0,0,1-.1.39l-13.9,8A.28.28,0,0,1,155.85,293.64Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.17,292.67a.3.3,0,0,1-.25-.14.29.29,0,0,1,.11-.39l13.9-8a.28.28,0,0,1,.39.11.28.28,0,0,1-.1.38l-13.91,8A.23.23,0,0,1,154.17,292.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.49,291.7a.29.29,0,0,1-.25-.14.29.29,0,0,1,.1-.39l13.91-8a.29.29,0,0,1,.39.1.28.28,0,0,1-.11.39l-13.9,8A.27.27,0,0,1,152.49,291.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.8,290.73a.28.28,0,0,1-.24-.15.28.28,0,0,1,.1-.39l13.9-8a.28.28,0,0,1,.29.49l-13.91,8A.33.33,0,0,1,150.8,290.73Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.12,289.75a.28.28,0,0,1-.14-.53l13.9-8a.29.29,0,0,1,.39.11.29.29,0,0,1-.11.39l-13.9,8A.32.32,0,0,1,149.12,289.75Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.43,288.78a.28.28,0,0,1-.24-.14.29.29,0,0,1,.1-.39l13.91-8a.27.27,0,0,1,.38.11.28.28,0,0,1-.1.39l-13.9,8A.28.28,0,0,1,147.43,288.78Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.75,287.81a.3.3,0,0,1-.25-.14.29.29,0,0,1,.11-.39l13.9-8a.28.28,0,0,1,.29.49l-13.91,8A.23.23,0,0,1,145.75,287.81Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.07,286.84a.29.29,0,0,1-.15-.53l13.91-8a.29.29,0,0,1,.39.1.28.28,0,0,1-.11.39l-13.9,8A.43.43,0,0,1,144.07,286.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.38,285.86a.27.27,0,0,1-.24-.14.28.28,0,0,1,.1-.39l13.9-8a.28.28,0,0,1,.39.1.29.29,0,0,1-.1.39l-13.91,8A.32.32,0,0,1,142.38,285.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.7,284.89a.28.28,0,0,1-.14-.53l13.9-8a.29.29,0,1,1,.28.5l-13.9,8A.23.23,0,0,1,140.7,284.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,283.92a.28.28,0,0,1-.24-.14.29.29,0,0,1,.1-.39l13.91-8a.29.29,0,0,1,.39.11.28.28,0,0,1-.11.38l-13.9,8A.28.28,0,0,1,139,283.92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.33,283a.3.3,0,0,1-.25-.14.29.29,0,0,1,.11-.39l13.9-8a.28.28,0,1,1,.29.49l-13.91,8A.23.23,0,0,1,137.33,283Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.25,295.59a.27.27,0,0,1-.25-.15.27.27,0,0,1,.11-.38l14.7-8.51a.28.28,0,0,1,.29.49l-14.71,8.51A.33.33,0,0,1,159.25,295.59Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.6,285a1.21,1.21,0,0,0-.57-.37,2.34,2.34,0,0,1-.27-.14c-.13-.2-.3-.54-.08-.58s.4.12.54.16.07-.1,0-.12c-.25-.1-.72-.4-.82,0a.62.62,0,0,0,.05.39.8.8,0,0,0-.36-.07c-.12,0-.22,0-.26.15a.27.27,0,0,0,0,.16.13.13,0,0,0,.11.12h-.13c-.17,0-.65-.12-.77.1s.06.21.05.25-.35.13-.41.17,0,.11,0,.12a4.32,4.32,0,0,1-.51,0c-.28,0-1-.08-.88.35,0,0,0,0,.06.11a.54.54,0,0,0,0,.11s0,0-.07.05-.12,0-.15.07.07.22-.09.33-.72-.15-1,0,.07.56-.3.57c-.08,0,0,.12,0,.13.34,0,.3,0,.37-.32.11-.46.8-.14,1.18-.25.05,0,.05-.07,0-.1s0-.26.17-.33a.07.07,0,0,0,0-.1c0-.07-.19-.3-.1-.41a1.7,1.7,0,0,1,.41,0c.3,0,.6,0,.9,0a.06.06,0,0,0,.06-.08c0-.1.34-.16.43-.18a.06.06,0,0,0,0-.08c-.19-.46.5-.29.78-.25.06,0,.1,0,.08-.08s-.39-.32,0-.37a.68.68,0,0,1,.31.07,2.16,2.16,0,0,0,.71.73C166.53,285.43,166.81,285.33,166.6,285Zm-.13.08c.09.12-.18,0-.21,0a1,1,0,0,1-.36-.38l.21.11A.86.86,0,0,1,166.47,285.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.64,288c0-.2,0-.42.13-.45s0-.13,0-.13c-.25,0-.33.21-.29.47a2,2,0,0,0-.32-.11c-.16,0-.27,0-.32.13s0,.17,0,.26.12.08-.07.13a.91.91,0,0,1-.23,0,.35.35,0,0,0-.34.11c-.13.1.18.15-.18.09-.1,0-.19-.06-.29,0s-.2.06-.18.21.15.16.15.2c0,.32-.34.05-.47,0s-.09,0-.09.05.11.21-.12.23c0,0-.19-.09-.24-.09s-.28.19-.47.18-.07,0-.06.08.13.23-.16.36l-.33,0c-.09,0,0,.13,0,.14s.58.2.72,0-.1-.29,0-.37.26-.08.29-.09a.51.51,0,0,1,.22-.06s.08.06.12.06.11,0,.17,0,.06-.1.08-.11-.07-.07,0-.11.14.05.21.07.27.12.36,0-.1-.26-.08-.36.38-.06.52-.16,0,0,0-.07c-.09-.31.48-.06.66-.1a.07.07,0,0,0,.07-.06l-.08-.2c0-.19.31-.17.43-.14.11.39.42.77.75.67a.07.07,0,0,0,0-.06C160.25,288.39,160,288.13,159.64,288Zm.12.31,0-.09c.11.08.22.18.23.23S159.8,288.32,159.76,288.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.7,290a1.27,1.27,0,0,0-.57-.36l-.28-.14c-.12-.21-.29-.55-.07-.59a1.85,1.85,0,0,1,.54.16c.08,0,.07-.09,0-.12-.25-.09-.72-.4-.83,0a.71.71,0,0,0,.06.39.8.8,0,0,0-.36-.07c-.12,0-.22,0-.26.15s0,.11,0,.17.1.11.12.12h-.13c-.18,0-.66-.13-.77.09s.06.22.05.25-.35.13-.41.17,0,.11,0,.12a4.32,4.32,0,0,1-.51,0c-.28,0-1-.08-.88.35,0,.05,0,0,.06.11s0,.1,0,.11,0,0-.07.06-.12,0-.15.06.07.23-.1.33-.71-.15-.95,0,.07.56-.3.57c-.09,0,0,.12,0,.13.35,0,.31,0,.38-.32.11-.46.8-.14,1.18-.25,0,0,0-.07,0-.1s0-.25.17-.33a.07.07,0,0,0,0-.1c0-.07-.19-.3-.1-.41s.36,0,.41-.05c.3,0,.6,0,.9,0a.07.07,0,0,0,.06-.09c-.05-.09.34-.16.43-.18s.05-.05,0-.08c-.19-.46.5-.29.78-.24a.07.07,0,0,0,.08-.09c0-.16-.39-.31,0-.37a.68.68,0,0,1,.31.07,2.2,2.2,0,0,0,.71.74C164.63,290.41,164.9,290.31,164.7,290Zm-.13.08c.09.12-.18,0-.21,0a.94.94,0,0,1-.36-.38l.21.11A.86.86,0,0,1,164.57,290.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,286.47c-.05-.2-.06-.42.13-.45s0-.13,0-.13c-.25,0-.33.21-.3.47a1.67,1.67,0,0,0-.31-.11c-.16,0-.27,0-.32.13s0,.17,0,.26.12.08-.08.13a1,1,0,0,1-.23,0,.36.36,0,0,0-.34.11c-.12.1.19.15-.18.09a.86.86,0,0,0-.28,0c-.13,0-.21.07-.18.22s.15.16.15.2c0,.32-.35.05-.48,0s-.08,0-.08.05.1.21-.12.23c0,0-.19-.09-.24-.09s-.28.19-.48.18c0,0-.07,0,0,.08s.13.23-.16.36l-.34,0c-.08,0,0,.13,0,.14s.58.2.71,0-.09-.29,0-.37.25-.08.28-.09a.6.6,0,0,1,.23-.06s.07.06.11.06.12,0,.17,0,.06-.1.09-.11-.07-.08,0-.11.14.05.2.07.28.12.37,0-.1-.26-.08-.36.37-.06.52-.16a.06.06,0,0,0,0-.07c-.09-.31.48-.06.66-.1s.07,0,.06-.06a1.5,1.5,0,0,0-.07-.2c.05-.19.31-.17.42-.14.12.39.42.77.76.67a.07.07,0,0,0,0-.06C169.57,286.91,169.28,286.65,169,286.47Zm.12.31a.39.39,0,0,1,0-.09.81.81,0,0,1,.23.23C169.34,287.11,169.12,286.84,169.09,286.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.33,279.34a1.27,1.27,0,0,0-.57-.36l-.27-.14c-.13-.21-.3-.54-.08-.59a1.85,1.85,0,0,1,.54.16c.08,0,.07-.09,0-.12-.25-.09-.72-.4-.82,0a.61.61,0,0,0,.05.39.8.8,0,0,0-.36-.07c-.12,0-.22,0-.26.15s0,.11,0,.17.1.11.12.12h-.13c-.18,0-.65-.13-.77.09s.06.22,0,.25-.35.13-.41.17,0,.11,0,.12a4.32,4.32,0,0,1-.51,0c-.28,0-1-.08-.88.35,0,0,.05,0,.06.12s0,.09,0,.1,0,0-.07.06-.12,0-.15.06.07.23-.1.33-.71-.15-.95,0,.07.56-.3.57c-.09,0,0,.12,0,.13.35,0,.31,0,.38-.32.11-.46.8-.14,1.18-.25,0,0,0-.07,0-.1s0-.25.17-.32a.07.07,0,0,0,0-.1c0-.08-.19-.31-.1-.42s.36,0,.41-.05c.3,0,.6,0,.9,0a.07.07,0,0,0,.06-.09c0-.09.34-.16.43-.18s0-.05,0-.08c-.19-.46.5-.29.78-.24a.07.07,0,0,0,.08-.09c0-.16-.39-.31,0-.37a.68.68,0,0,1,.31.07,2.2,2.2,0,0,0,.71.74C156.26,279.75,156.54,279.66,156.33,279.34Zm-.13.08c.09.12-.18,0-.21,0a.94.94,0,0,1-.36-.38l.21.11A.86.86,0,0,1,156.2,279.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.37,282.27c-.05-.2-.05-.42.13-.45s0-.13,0-.13c-.25,0-.33.21-.3.47a1.11,1.11,0,0,0-.31-.1c-.16,0-.27,0-.32.13s.05.16,0,.25.12.08-.07.13a1.79,1.79,0,0,1-.23,0c-.2,0-.22,0-.34.1s.18.16-.18.1a.73.73,0,0,0-.29,0c-.13,0-.2.07-.18.21s.15.16.15.2c0,.32-.34.05-.48,0s-.08,0-.08.05.11.22-.12.23c0,0-.19-.09-.24-.09s-.28.19-.47.18a.05.05,0,0,0-.06.08c.05.15.13.24-.16.36l-.33,0c-.09,0,0,.13,0,.14s.58.2.72,0-.1-.29-.05-.37.25-.08.29-.09a.71.71,0,0,1,.22-.06s.08.06.12.06.11,0,.16,0,.07-.09.09-.11-.07-.07,0-.11.14.05.21.07.27.12.36,0-.1-.25-.08-.36.37-.05.52-.15a.05.05,0,0,0,0-.07c-.09-.32.48-.07.66-.1s.07,0,.06-.07a1.5,1.5,0,0,0-.07-.2c.05-.19.31-.17.43-.13.11.38.42.77.75.66a.07.07,0,0,0,0-.06C150,282.71,149.68,282.45,149.37,282.27Zm.12.32,0-.1a1,1,0,0,1,.23.23C149.75,282.91,149.52,282.64,149.49,282.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.43,284.32a1.27,1.27,0,0,0-.57-.36l-.28-.14c-.13-.21-.29-.54-.07-.58s.4.11.54.15.06-.09,0-.11c-.25-.1-.72-.41-.83,0a.69.69,0,0,0,.06.39.8.8,0,0,0-.36-.07c-.12,0-.22,0-.26.15s0,.11,0,.17.1.11.12.12h-.13c-.18,0-.66-.12-.77.09s.06.22,0,.25-.35.13-.41.17,0,.11,0,.12a2.77,2.77,0,0,1-.5,0c-.28,0-1-.08-.88.35,0,.05.05,0,.06.12a.16.16,0,0,0,0,.1s0,0-.07.06-.12,0-.15.07.07.22-.1.32-.71-.15-.95,0,.07.56-.3.56c-.09,0,0,.13,0,.13.35,0,.31,0,.38-.32.11-.46.79-.14,1.18-.25.05,0,.05-.06,0-.1s0-.25.17-.32a.07.07,0,0,0,0-.1c0-.08-.19-.31-.1-.42a2.48,2.48,0,0,1,.41,0,6.76,6.76,0,0,1,.9,0,.07.07,0,0,0,.06-.09c-.05-.09.34-.15.43-.17a.07.07,0,0,0,0-.08c-.19-.47.49-.3.78-.25a.07.07,0,0,0,.08-.09c-.05-.15-.39-.31,0-.37a.71.71,0,0,1,.31.08,2.26,2.26,0,0,0,.71.73C154.36,284.73,154.63,284.64,154.43,284.32Zm-.13.09c.09.11-.18,0-.22,0a1,1,0,0,1-.35-.38l.21.11A.8.8,0,0,1,154.3,284.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.7,280.79c0-.2-.06-.42.13-.45s0-.13,0-.13c-.25,0-.33.21-.3.47a1.11,1.11,0,0,0-.31-.1c-.16,0-.27,0-.32.13s0,.16,0,.25.12.08-.08.13a2,2,0,0,1-.23,0c-.2,0-.22,0-.34.1s.19.16-.18.1a.66.66,0,0,0-.28,0c-.14,0-.21.07-.18.21s.15.16.15.2c0,.32-.35.05-.48,0s-.08,0-.08.05.1.22-.13.23a1.85,1.85,0,0,0-.23-.09c-.15,0-.29.19-.48.18s-.07,0-.05.08.13.24-.16.36l-.34,0c-.08,0,0,.13,0,.14s.58.2.71,0-.09-.29-.05-.37.26-.08.29-.09a.86.86,0,0,1,.23-.06s.07.06.11.06.12,0,.17,0,.06-.09.08-.11-.06-.07,0-.11.13.05.2.07.28.12.37,0-.1-.26-.08-.36.37-.05.52-.15a.07.07,0,0,0,0-.07c-.09-.32.48-.07.66-.11,0,0,.07,0,.06-.06a1.5,1.5,0,0,0-.07-.2c0-.19.3-.17.42-.13.12.38.42.77.75.66a.06.06,0,0,0,.05-.06C159.3,281.23,159,281,158.7,280.79Zm.12.31a.26.26,0,0,1,0-.09,1,1,0,0,1,.23.23C159.07,281.43,158.85,281.16,158.82,281.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.48,287.75a1.21,1.21,0,0,0-.57-.36l-.27-.14c-.13-.21-.3-.54-.07-.59a2,2,0,0,1,.54.16c.08,0,.06-.09,0-.11-.24-.1-.72-.41-.82,0a.62.62,0,0,0,.06.39A.84.84,0,0,0,154,287c-.12,0-.21,0-.26.15s0,.11,0,.17.09.11.12.12h-.14c-.17,0-.65-.13-.76.09s.06.22,0,.25-.35.13-.41.17,0,.11,0,.12a4.31,4.31,0,0,1-.51,0c-.27,0-1-.08-.87.35,0,.05,0,0,.05.12l0,.1s0,0-.06.06-.12,0-.16.06.07.23-.09.33-.72-.15-.95,0,.06.57-.31.57c-.08,0,0,.13,0,.13.34,0,.31,0,.37-.32.11-.46.8-.14,1.19-.25a.07.07,0,0,0,0-.1c-.11-.16,0-.25.17-.32a.06.06,0,0,0,0-.1c0-.08-.18-.31-.09-.42s.36,0,.41-.05a9,9,0,0,1,.9,0,.06.06,0,0,0,.05-.09c0-.09.35-.15.43-.17a.07.07,0,0,0,0-.09c-.18-.46.5-.29.78-.24a.07.07,0,0,0,.08-.09c0-.16-.38-.31,0-.37a.62.62,0,0,1,.32.08,2.16,2.16,0,0,0,.71.73C155.42,288.16,155.69,288.07,155.48,287.75Zm-.12.08c.08.12-.19,0-.22,0a1,1,0,0,1-.36-.38,1.48,1.48,0,0,0,.22.11A.93.93,0,0,1,155.36,287.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.87,284.53c-.05-.2-.06-.42.13-.44s0-.14,0-.14c-.26,0-.33.21-.3.47a1.36,1.36,0,0,0-.31-.1c-.17,0-.27,0-.33.13s0,.16,0,.25.13.08-.07.13-.17,0-.23,0-.22,0-.34.1.18.16-.18.1a.68.68,0,0,0-.28,0c-.14,0-.21.07-.19.22s.16.15.16.19c0,.32-.35.05-.48,0s-.08,0-.08.05.1.22-.13.23c0,0-.18-.09-.23-.09s-.29.2-.48.18-.07,0-.06.09.14.23-.15.35c0,0-.35,0-.35,0s0,.14,0,.14.59.2.72,0-.1-.28,0-.37.26-.08.29-.09a1.28,1.28,0,0,1,.23-.06s.07.07.11.06.12,0,.17,0,.06-.09.08-.11-.06-.07,0-.1.13,0,.2.07.27.11.37,0-.1-.25-.08-.36.37,0,.52-.15a.07.07,0,0,0,0-.07c-.09-.32.48-.07.66-.1a.07.07,0,0,0,.06-.07l-.07-.2c0-.19.3-.16.42-.13.12.38.42.77.75.66,0,0,.05,0,0,0C159.47,285,159.18,284.71,158.87,284.53Zm.12.32-.05-.09a.76.76,0,0,1,.24.23C159.24,285.18,159,284.9,159,284.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.74,281.92a.09.09,0,0,0,0-.07c-.05-.2-.28-.05-.32.07s.05.16,0,.25.13.08-.07.13a2,2,0,0,1-.23,0c-.2,0-.22,0-.34.1s.18.16-.18.1a.68.68,0,0,0-.28,0c-.14,0-.21.07-.19.21s.16.16.16.2c0,.32-.35,0-.48,0s-.08,0-.08,0,.1.22-.13.23c0,0-.18-.09-.23-.09s-.29.19-.48.18-.07,0-.06.08.14.24-.16.36l-.34,0c-.07,0,0,.13,0,.14s.59.2.72,0-.1-.29,0-.37.26-.08.29-.09a.77.77,0,0,1,.23-.06s.07.06.11.06.12,0,.17,0,.06-.09.08-.11-.06-.07,0-.11.13,0,.2.07.27.12.37,0-.1-.25-.08-.36.37-.05.52-.15a.1.1,0,0,0,0-.07c-.09-.32.48-.07.66-.1a.07.07,0,0,0,.06-.07.94.94,0,0,1,0-.41A.29.29,0,0,0,162.74,281.92Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--green-pencil--inject-1--inject-92"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-1--inject-92",
    points: "171.33 302.51 173.71 303.88 192.46 292.91 194.53 290.47 190.21 291.61 171.33 302.51",
    style: {
      fill: "#455a64",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.39,289.94l4-.78a.12.12,0,0,1,.12.2l-2.71,3.07Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.5,289.36a.12.12,0,0,0-.12-.2l-.78.15h0a.69.69,0,0,1,.32.64V290Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.89,301l.33-.19.39-.22,14.18-8.13a2.09,2.09,0,0,0-1.4-2.49l-14.17,8.13-.75.43C176,298.25,177.39,300.71,176.89,301Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.14,300.26l.73-.42c.21-.11.09-.64-.16-1.19-.33-.73-1-1.43-1.28-1.28l-.53.31-.19.11c.28-.15.94.56,1.27,1.28.24.53.36,1,.18,1.18h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.32,300.16c.5-.27-.93-2.74-1.43-2.47l-.73.41c.5-.26,1.93,2.21,1.43,2.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.89,301l.72-.41c.5-.26-.86-2.65-1.39-2.49h0l-.72.42C176,298.25,177.39,300.71,176.89,301Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.52,289.23l-.14-.07-2.9,1.58-15,8.6s-.06,0-.07,0c.42.67.74,1.51.46,1.65l.33-.19.39-.22,14.18-8.13h0l2.71-3.07A.15.15,0,0,0,194.52,289.23Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.83,302.72l3.06-1.75c.22-.11.1-.63-.15-1.18-.33-.73-1-1.44-1.27-1.29h0l-3.08,1.76c-.61.35,0,1.68.64,2.27A.72.72,0,0,0,173.83,302.72Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,301.77a2.2,2.2,0,0,0-1.24-1.51.54.54,0,0,0-.46.06c-.46.43.07,1.65.72,2.21a.74.74,0,0,0,.79.2C174.05,302.59,174.13,302.24,174,301.77Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Papers--inject-1--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-1--inject-92",
    d: "M223.19,330.64a2.4,2.4,0,0,0,1.2-.3l20-11.55a1.09,1.09,0,0,0,.61-.92,1.07,1.07,0,0,0-.61-.91l-3.57-2.07,1.71-1a1,1,0,0,0,0-1.84l-29.46-17a2.4,2.4,0,0,0-1.2-.3,2.45,2.45,0,0,0-1.2.3l-20,11.55a1.09,1.09,0,0,0-.61.92,1.07,1.07,0,0,0,.61.91l3.57,2.07-1.71,1a1.07,1.07,0,0,0-.61.91,1.09,1.09,0,0,0,.61.92l29.45,17A2.45,2.45,0,0,0,223.19,330.64Z",
    style: {
      fill: "#455a64",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.32,310.87a.69.69,0,0,1,.41-.58l20-11.56a2.22,2.22,0,0,1,2,0l29.46,17a.71.71,0,0,1,.41.58v.91a.71.71,0,0,1-.41.58l-20,11.56a2.22,2.22,0,0,1-2,0l-29.46-17a.71.71,0,0,1-.41-.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.22,315.74l-29.46-17a2.22,2.22,0,0,0-2,0l-20,11.56a.61.61,0,0,0,0,1.16l29.46,17a2.22,2.22,0,0,0,2,0l20-11.56A.61.61,0,0,0,244.22,315.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.2,328.7v.9a2,2,0,0,0,1-.24l20-11.55a.71.71,0,0,0,.42-.58v-.91a.69.69,0,0,1-.42.58l-20,11.56A2.05,2.05,0,0,1,223.2,328.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.46,306a.69.69,0,0,1,.41-.58l20-11.56a2.22,2.22,0,0,1,2,0l29.46,17a.71.71,0,0,1,.41.58v.91a.71.71,0,0,1-.41.58l-20,11.55a2.22,2.22,0,0,1-2,0l-29.46-17a.71.71,0,0,1-.41-.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.36,310.86l-29.46-17a2.22,2.22,0,0,0-2,0l-20,11.56a.61.61,0,0,0,0,1.16l29.46,17a2.22,2.22,0,0,0,2,0l20-11.56A.61.61,0,0,0,242.36,310.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.34,323.82v.9a2,2,0,0,0,1-.24l20-11.55a.71.71,0,0,0,.42-.58v-.91a.71.71,0,0,1-.42.58l-20,11.56A2.05,2.05,0,0,1,221.34,323.82Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Folder--inject-1--inject-92"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.3,305.55a2.19,2.19,0,0,1-1.1-.28l-30.8-17.78a1.19,1.19,0,0,1-.05-2.14l25.44-16.18a2.28,2.28,0,0,1,1.21-.32,2.21,2.21,0,0,1,1.1.27l9.16,5.3a1.67,1.67,0,0,1,.65,2.2l-.37.72a.32.32,0,0,0,.12.4l18.46,10.74a1.21,1.21,0,0,1,.05,2.15l-22.66,14.59A2.31,2.31,0,0,1,269.3,305.55Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M269.75,303.72l23.07-13.36a.5.5,0,0,0,0-.95l-31.64-18a1.81,1.81,0,0,0-1.65,0l-22.86,13.2a.5.5,0,0,0,0,.95l31.43,18.15A1.84,1.84,0,0,0,269.75,303.72Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.75,303.72l23.07-13.36a.5.5,0,0,0,0-.95l-31.64-18a1.81,1.81,0,0,0-1.65,0l-22.86,13.2a.5.5,0,0,0,0,.95l31.43,18.15A1.84,1.84,0,0,0,269.75,303.72Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M236.65,284.58l26-16.5a1.74,1.74,0,0,1,1.63,0l9.35,5.4a1,1,0,0,1,.39,1.32l-.38.75a1,1,0,0,0,.39,1.32l18.84,11a.53.53,0,0,1,0,1l-23.13,14.89a1.72,1.72,0,0,1-1.62,0l-31.43-18.15A.53.53,0,0,1,236.65,284.58Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--black-pencil--inject-1--inject-92"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "freepik--shadow--inject-1--inject-92",
    points: "329.97 273.07 310.16 284.48 312.54 285.85 332.21 274.36",
    style: {
      fill: "#455a64",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pencil--inject-1--inject-92"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M331.9,273.63l2.35-2.8a.11.11,0,0,0-.11-.18l-3.59.79Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.16,270.65h0l-3.59.79.71,1.16.39-.24,2.51-1.59Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.14,270.65a.11.11,0,0,1,.11.18l-.46.54h0a.62.62,0,0,0-.36-.53l-.05,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.29,281.25l.29-.17.35-.21,15.62-9.43a1.62,1.62,0,0,1,1,.66,1.68,1.68,0,0,1,.36,1.52l-15.62,9.43-.67.4C316,283.17,314.71,281,314.29,281.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.29,281.25l.29-.17.35-.21,15.62-9.43a1.74,1.74,0,0,1,1.14.89l-16.3,9.95s0,.06,0,.06C315,281.72,314.52,281.1,314.29,281.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.39,280.58l.65-.39c.18-.12.54.21.86.65s.7,1.4.45,1.56l-.47.29-.18.1c.25-.16,0-1-.45-1.56-.3-.42-.65-.74-.84-.66h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.55,280.49c.43-.28,1.74,1.92,1.32,2.2l-.65.39c.43-.27-.89-2.48-1.32-2.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.29,281.25l.64-.38c.41-.28,1.7,1.84,1.35,2.18l0,0-.65.38C316,283.17,314.71,281,314.29,281.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.26,270.69a.11.11,0,0,0-.09-.05A.11.11,0,0,1,334.26,270.69Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.57,282.9l2.72-1.65c.18-.12.54.21.86.64.43.58.7,1.4.46,1.56h0l-2.73,1.65c-.54.33-1.33-.69-1.5-1.48A.65.65,0,0,1,311.57,282.9Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.4,283.17a2,2,0,0,1,.64,1.64.46.46,0,0,1-.24.33c-.54.18-1.26-.77-1.42-1.52a.65.65,0,0,1,.18-.71C311.77,282.79,312.08,282.87,312.4,283.17Z",
    style: {
      opacity: 0.1
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.720469e35fb8149c8c60353e001dea4e.svg";
export { ForwardRef as ReactComponent };